/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useState } from 'react';

import ManagedCollectionsModule from 'bundles/browse-common/components/ComplexCollectionComponent/ManagedCollectionsModule';
import { initialComplexCollection } from 'bundles/browse-common/components/ComplexCollectionComponent/initialComplexCollection';
import { toCarouselCollection } from 'bundles/browse-common/components/ComplexCollectionComponent/toCarouselCollection';
import { toCollectionsModuleFilter } from 'bundles/browse-common/components/ComplexCollectionComponent/toCollectionsModuleFilter';
import { useQueryBrowseComplexCollection } from 'bundles/browse-common/components/ComplexCollectionComponent/useBrowseComplexCollection';
import SectionHeadingComponent from 'bundles/browse-common/components/SectionHeadingComponent';
import type { ComplexCollection, ComplexCollectionFilter } from 'bundles/browse-common/types/complexCollections';

type Props = {
  title: string;
  filters: ComplexCollectionFilter[];
  firstCollection: ComplexCollection;
};

const styles = {
  heading: css`
    margin-bottom: var(--cds-spacing-50);
  `,
};

const ComplexCollectionComponent = (props: Props) => {
  const { title, filters, firstCollection } = props;

  const [collections, setCollections] = useState(initialComplexCollection(firstCollection, filters));

  const query = useQueryBrowseComplexCollection();

  const [loading, setLoading] = useState(false);

  const collectionsModuleFilters = filters.map(toCollectionsModuleFilter);

  const collectionsModuleCollections = collections.map(toCarouselCollection);

  const handleFilterChange = async (index: number, filterName: string) => {
    if (!collections[index].entities) {
      setLoading(true);
      const filter = filters[index];
      try {
        const result = await query({
          queryCollectionId: filter.context.id,
          additionalInput: filter.context.additionalInput,
        });
        const collection: ComplexCollection | undefined = result.data.Recommendations?.queryCollection;
        if (collection) {
          const newCollections = [...collections];
          newCollections[index] = collection;
          setCollections(newCollections);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <ManagedCollectionsModule
      alwaysShowChipFilters
      filters={collectionsModuleFilters}
      collections={collectionsModuleCollections}
      isCollectionsLoading={loading}
      onFilterChange={handleFilterChange}
      layout="text-top/image-bottom"
      customHeadline={<SectionHeadingComponent additionalStyles={styles.heading}>{title}</SectionHeadingComponent>}
    />
  );
};

export default ComplexCollectionComponent;
